import { render } from "./PavilionElement.vue?vue&type=template&id=fae2ad18&scoped=true"
import script from "./PavilionElement.vue?vue&type=script&lang=js"
export * from "./PavilionElement.vue?vue&type=script&lang=js"

import "./PavilionElement.vue?vue&type=style&index=0&id=fae2ad18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fae2ad18"]])

export default __exports__